module.exports = __webpack_public_path__ + "static/media/two-way-communication.a49ab7d0.png";